export default "__VITE_ASSET__CUTeN3tc__"